import { Component, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as html2pdf from 'html2pdf.js';
import { Subscription } from 'rxjs';
import { IRelatorioCabecalhoEmpresaResponseData } from 'src/app/interfaces/relatorio/EmpresaCabecalhoRelatorio/IRelatorioCabecalhoEmpresaResponseData';
import { ObterEmpresaService } from 'src/app/services/relatorios/obter-empresa/obter-empresa.service';

@Component({
  selector: 'app-relatorio-exibido',
  templateUrl: './relatorioExibido.component.html',
  styleUrls: ['./relatorioExibido.component.scss']
})
export class RelatorioExibidoComponent implements OnInit {
  private subscriptions$ = new Subscription();
  codigoContrato: string;
  empresaRelatorioCabecalho: IRelatorioCabecalhoEmpresaResponseData;
  tipoRelatorioNome: string;

  constructor(
    private modalService: NgbModal,
    private obterEmpresaService: ObterEmpresaService,
    private route: ActivatedRoute
  ) {}
  @ViewChild('ModalExibirRelatorio') template: TemplateRef<any>;

  openModal() {
    this.modalService.open(this.template, {
      centered: true,
      size: 'lg'
    });
  }

  getDadosRelatorio() {
    this.subscriptions$.add(
      this.obterEmpresaService
        .postRelatorioEmpresa({
          codigoContrato: this.codigoContrato
        })
        .subscribe({
          next: ({ data }) => {
            this.empresaRelatorioCabecalho = data;
          }
        })
    );
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (this.codigoContrato = params['codContrato'])
    );
    this.getDadosRelatorio();
    this.nomearTipoRelatorio();
  }
  exportarPdf() {
    const options = {
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'landscape', format: 'a4' }
    };
    const content: Element | null = document.getElementById('exportar-pdf');

    const pdfExporter = html2pdf().from(content).set(options);

    this.nomearTipoRelatorio();
    pdfExporter.save(
      `RELATÓRIO-${this.tipoRelatorioNome}-${this.codigoContrato}.pdf`
    );
  }

  nomearTipoRelatorio() {
    const tipoRelatorio = {
      '1': 'FRANQUIA-GLOBAL',
      '2': 'TAXA-FIXA-E-PRODUÇÃO',
      '3': 'FRANQUIA-POR-MÁQUINA',
      '4': 'INFORMÁTICA'
    };
    this.tipoRelatorioNome =
      tipoRelatorio[
        this.empresaRelatorioCabecalho?.razaoNotaFiscalRelatorioTipo
      ];
  }

  exportarCsv() {}
  exportarXlsx() {}

  fecharModal() {
    this.modalService.dismissAll();
  }
}
